module.exports = __webpack_public_path__ + "img/jp.e47d4662.svg";